module.exports = __webpack_public_path__ + "static/media/brown_circles.ec1de649.svg";